const TrackIcon  = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.66667 3.25H9.02866C11.568 3.25 12.8377 3.25 13.3197 3.70607C13.7363 4.10031 13.921 4.68107 13.8085 5.24351C13.6783 5.89418 12.6418 6.62738 10.5686 8.09378L7.18143 10.4896C5.10825 11.956 4.07166 12.6892 3.94153 13.3398C3.82905 13.9023 4.01368 14.483 4.4303 14.8773C4.91228 15.3333 6.18196 15.3333 8.72134 15.3333H9.5M5.75 3.25C5.75 4.63071 4.63071 5.75 3.25 5.75C1.86929 5.75 0.75 4.63071 0.75 3.25C0.75 1.86929 1.86929 0.75 3.25 0.75C4.63071 0.75 5.75 1.86929 5.75 3.25ZM17.4167 14.9167C17.4167 16.2974 16.2974 17.4167 14.9167 17.4167C13.536 17.4167 12.4167 16.2974 12.4167 14.9167C12.4167 13.536 13.536 12.4167 14.9167 12.4167C16.2974 12.4167 17.4167 13.536 17.4167 14.9167Z"
        stroke="#17253C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TrackIcon
